module.exports = "https://cdn.hellotech.com/client-assets/universal_remotes_mobile_9cc6e85523d00c1bfe3abbf165319368.webp";